import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QuestionnaireComponent } from './questionnaire.component';
import { QuestionnaireSplashComponent } from './splash/splash.component';
import { QuestionnaireFormComponent } from './form/form.component';
import { QuestionnairePreviewComponent } from './preview/preview.component';

const baseBreadcrumbs = [
  {
    label: 'projects.title',
    url: 'eyrus/projects'
  },
  {
    label: ':projectName',
    path: 'eyrus/contracts/:rootContractId/daily-status',
    inTitle: true
  },
  {
    label: 'projects.setting.title',
    path: 'eyrus/contracts/:rootContractId/settings',
    inTitle: true
  }
];

const routes: Routes = [
  {
    path: '',
    component: QuestionnaireComponent,
    children: [
      {
        path: 'access',
        children: [
          {
            path: 'general',
            component: QuestionnaireSplashComponent,
            data: {
              viewType: 'general',
            }
          },
          {
            path: 'safety',
            component: QuestionnaireSplashComponent,
            data: {
              viewType: 'safety',
            }
          }
        ]
      },
      {
        path: 'add',
        children: [
          {
            path: 'general',
            component: QuestionnaireFormComponent,
            data: {
              viewType: 'general',
              title: 'questionnaire.generalQuestionnaire',
              subview: true,
              stepsBack: 3,
              type: 'basic',
              questionnaireType: 'generalQuestionnaire',
              breadcrumbs: [
                ...baseBreadcrumbs,
                {
                  label: 'projects.setting.dailyLogSetup',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log',
                  inTitle: true
                },
                {
                  label: 'questionnaire.generalQuestionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/general',
                  inTitle: true
                },
              ]
            }
          },
          {
            path: 'safety',
            component: QuestionnaireFormComponent,
            data: {
              viewType: 'safety',
              title: 'questionnaire.safetyQuestionnaire',
              subview: true,
              stepsBack: 3,
              type: 'basic',
              breadcrumbs: [
                ...baseBreadcrumbs,
                {
                  label: 'projects.setting.dailyLogSetup',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log',
                  inTitle: true
                },
                {
                  label: 'questionnaire.safetyQuestionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/safety',
                  inTitle: true
                }
              ]
            }
          },
          {
            path: 'walkthrough',
            component: QuestionnaireFormComponent,
            data: {
              viewType: 'walkthrough',
              contentType: 'walkthrough',
              title: 'questionnaire.walkthrough',
              subview: true,
              stepsBack: 3,
              type: 'basic',
              breadcrumbs: [
                ...baseBreadcrumbs,
                {
                  label: 'projects.setting.dailyLogSetup',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log',
                  inTitle: true
                },
                {
                  label: 'questionnaire.walkthrough',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/walkthrough',
                  inTitle: true
                }
              ]
            }
          },
          {
            path: 'safety/preview',
            component: QuestionnairePreviewComponent,
            data: {
              viewType: 'safety',
              title: 'questionnaire.previewQuesstionnaire',
              subview: true,
              stepsBack: 1,
              type: 'basic',
              questionnaireType: 'safetyQuestionnaire',
              breadcrumbs: [
                ...baseBreadcrumbs,
                {
                  label: 'projects.setting.dailyLogSetup',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log',
                  inTitle: true
                },
                {
                  label: 'questionnaire.safetyQuestionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/safety',
                  inTitle: true
                },
                {
                  label: 'questionnaire.previewQuesstionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/safety/preview',
                  inTitle: true
                },
              ]
            }
          },
          {
            path: 'walkthrough/preview',
            component: QuestionnairePreviewComponent,
            data: {
              viewType: 'walkthrough',
              title: 'questionnaire.walkthrough',
              subview: true,
              stepsBack: 1,
              type: 'basic',
              questionnaireType: 'walkthrough',
              breadcrumbs: [
                ...baseBreadcrumbs,
                {
                  label: 'projects.setting.dailyLogSetup',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log',
                  inTitle: true
                },
                {
                  label: 'questionnaire.walkthrough',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/walkthrough',
                  inTitle: true
                },
                {
                  label: 'questionnaire.previewQuesstionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/walkthrough/preview',
                  inTitle: true
                },
              ]
            }
          },
          {
            path: 'general/preview',
            component: QuestionnairePreviewComponent,
            data: {
              viewType: 'general',
              title: 'questionnaire.previewQuesstionnaire',
              subview: true,
              stepsBack: 1,
              type: 'basic',
              questionnaireType: 'generalQuestionnaire',
              breadcrumbs: [
                ...baseBreadcrumbs,
                {
                  label: 'projects.setting.dailyLogSetup',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log',
                  inTitle: true
                },
                {
                  label: 'questionnaire.generalQuestionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/general',
                  inTitle: true
                },
                {
                  label: 'questionnaire.previewQuesstionnaire',
                  path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/general/preview',
                  inTitle: true
                },
              ]
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class QuestionnaireRoutingModule { }
